import { Area } from './area';
import { BioindicatorConfig } from './bioindicator';
import { Criteria } from './criteria';
import { CriticalInstrumentationDeletion, CriticalInstrumentationExecution } from './criticalInstrumentation';
import { EquipmentExecution, EquipmentQExecution } from './equipment';
import { Essay } from './essay';
import { Field } from './field';
import { GenericAttachment, GenericFilter } from './genericClass';
import { Protocol, ProtocolAir } from './protocol';
import { ReferenceDocument } from './referenceDocument';
import { Sensor } from './sensor';
import { ValidatorSpecifics } from './validatorSpecific';

export class Execution {
    id: number;

    idProtocol: number;
    nameProtocol: string;
    originalProtocolVersion: number;
    protocol: Protocol; // Puede no venir, no usar si no se está seguro

    idProcessType: number;
    processTranslation: string;

    idClient: number;
    nameClient: string;
    clientAddress: string;

    idPhase: number;
    phaseTranslation: string;

    usernameProjectManager: string;

    idInstrumentation: number; // FIXME: A desaparecer
    nameInstrumentation: string; // FIXME: A desaparecer

    regUser: string;
    modUser: string;

    regFc: Date;
    modFc: Date;

    idStatus: number;
    statusTranslation: string;

    reason: string;

    deviations: string;
    observations: string;

    according: boolean;
    accordingReason: string;

    projectNo: string;
    documentCode: string;
    clientDocumentCode: string;
    currentVersion: number;

    department: string;

    equipments: EquipmentExecution[] = [];
    essays: Essay[] = [];
    criticalInstrumentations: CriticalInstrumentationExecution[] = [];
    criticalInstrDeletions: CriticalInstrumentationDeletion[] = [];
    referenceDocs: ReferenceDocument[];

    // instrumentations: Instrumentation[]; // TODO: A implementar
    validator: ValidatorSpecifics; // FIXME: A desaparecer

    initWorkDate: Date;
    endWorkDate: Date;

    realizationDate: Date;
    conclusions: string;
}

export class ExecutionAudit {
    id: number;
    username: string;

    idAction: number;
    actionName: string;
    actionTranslation: string;

    idStatus: number;
    nameStatus: string;
    statusTranslation: string;

    date: Date;

    currentVersion: number;

    changes: string;
    test:number
    testName:string;
    testTransalation:string

    canDownload: boolean;
}

export class ExecutionQAuditFilter extends GenericFilter {
    idTestType: number;
}

export class ExecutionAttachment extends GenericAttachment {
    idExecution: number;
}

export class ExecutionQAttachment extends GenericAttachment {
    idExecution: number;
    idAttachment: number;
    fromProtocol: boolean;
}

export class ExecutionFilter extends GenericFilter {
    projectNo: string;
    documentCode: string;
    clientDocumentCode: string;
    documentCodeProtocol: string;

    idProtocol: number;

    idProcess: string;
    idClient: number;
    idPhase: number;
    idInstrumentation: number;

    idStatus: number;

    regUser: string;
    modUser: string;
    projectManager: string;

    regFcStart: Date;
    regFcEnd: Date;

    modFcStart: Date;
    modFcEnd: Date;

    workStartFcStart: Date;
    workStartFcEnd: Date;

    workEndFcStart: Date;
    workEndFcEnd: Date;

    realizationFcStart: Date;
    realizationFcEnd: Date;

    equipment: string;
    equipmentMaker: string;
    equipmentModel: string;
    equipmentSerialNum: string;
    equipmentInternalId: string;
    equipmentLocation: string;

    equipmentInventoryNum: string;
    
    department: string;

    areaName: string;

    roomName: string;
    compressGasCode: string;
    cols: string[];
}

export class ExecutionAir {
    id: number;

    idProtocol: number;
    nameProtocol: string;
    originalProtocolVersion: number;
    protocol: ProtocolInfo; // Puede no venir, no usar si no se está seguro

    idProcess: number;
    processTranslation: string;

    idClient: number;
    nameClient: string;
    clientAddress: string;

    usernameProjectManager: string;

    regUser: string;
    modUser: string;

    regFc: Date;
    modFc: Date;

    idStatus: number;
    statusTranslation: string;

    reason: string;

    deviations: string;
    observations: string;
    notes: string;

    customDeviations: string;
    customObservations: string;

    according: boolean;
    accordingReason: string;

    projectNo: string;
    documentCode: string;
    clientDocumentCode: string;
    currentVersion: number;

    referenceDocs: ReferenceDocument[];

    initWorkDate: Date;
    endWorkDate: Date;

    realizationDate: Date;
    conclusions: string;

    areas: Area[];
    areaNames: string;
    workOffline: boolean;
    lang: string;
}

export class ProtocolInfo {
    id: number;
    idProcess: number;
    idClient: number;
    observations: string;
    notes: string;
    documentCode: string;
    projectNo: string;
}

export class ExecutionQ{
    id: number;

    documentCode: string;
    documentCodeOriginal: string;
    clientDocumentCode: string;

    projectNo: string;
    
    idProtocol:number;
    protocolDocumentCode: string;
    originalProtocolVersion:number;

    idStatus: number;
    statusTranslation: string;

    observations: string;

    currentVersion: number;
    signedVersion: string;

    regUser: string;
    modUser: string;

    regFc: Date;
    modFc: Date;

    according: boolean;
    accordingReason: string;

    idClient: number;
    clientName: string;

    idPhase:number;
    idInstrumentation: number;
    idProcess:number;

    usernameProjectManager: string;

    reason: string;

    conclusions: string;

    department: string;

    notes: string;

    referenceDocs: ReferenceDocument[];

    equipments: EquipmentQExecution[];

    executionQTests: ExecutionQTest[] = [];

    deviations: ExecutionQTestDeviations[] = [];
    
    equipmentName: string;

    testPerformed: string[];

    lang: string;
}

export class ExecutionQFilter extends GenericFilter{

    documentCode: string;

    protocolDocumentCode: string;

    clientDocumentCode: string;
    projectNo: string;

    idProcess: string;
    idClient: number;
    idStatus: number;
    regFc: Date;

    regFcStart: Date;
    regFcEnd: Date;

    modFcStart: Date;
    modFcEnd: Date;

    projectManager: string;


}

export class ExecutionAuditFilter extends GenericFilter {
}

export class ExecutionAttachmentFilter extends GenericFilter {
}

export enum ExecutionStatus {
    EN_EJECUCION = 2,
    PENDIENTE_FIRMA = 4,
    FIRMADO = 5
}

export enum ExecutionActionEnum {
    CREATE = 1,
    SAVE = 2,
    PREPARE = 3,
    EXECUTE = 4,
    VALIDATED_BY_TECHNICIAN = 5,
    INVALIDATE_BY_TECHNICIAN = 6,
    VALIDATED_BY_DOCUMENTATION = 7,
    INVALIDATE_BY_DOCUMENTATION = 8,
    UPLOAD_PHOTO_SENSOR = 9,
    UPLOAD_EXCEL_SENSOR = 10,
    UPLOAD_PRIMARY_DATA_SENSOR = 11,
    UPLOAD_ATTACHMENT = 12,
    DELETE_ATTACHMENT = 13,
    MODIFY_CRITICAL_INSTR = 14,
    MODIFY_ESSAY = 15,
    MODIFY_SENSOR = 16,
    MODIFY_FIELD = 17,
    MODIFY_CRITERIA = 18,
    MODIFY_EQUIPMENT = 19
}

export class ExecutionQTest {
    id: number;
    idExecution: number;
    idTestType: number;
    executionQTestItemGroup: ExecutionQTestItemGroup[];
    executionQTestProbeTraceability: ExecutionQTestProbeTraceability[];
    executionQTestResults: ExecutionQTestResults[];
    executionQTestBioindicadores: ExecutionQTestBioindicadores[];
    executionQTestOQVerification: ExecutionQTestDataOQ[];
    executionQTestGeneralData: ExecutionQTestGeneralData[];
    executionQTestAttachment: ExecutionQTestAttachment[];
    deviations: ExecutionQTestDeviations[];
    executionQTestEssayGroup: ExecutionQTestEssayGroup[];
    executionQTestDataObservations: ExecutionQTestDataObservations[];
    executionQTestInstrumentalUsed: ExecutionQTestInstrumentalUsed[];
    executionQTestCriticalInstrumentation: ExecutionQTestCriticalInstrumentation[];
    idOffline: string;
    testDescription: string;

    idStatus: number;  
      
    regUser: string;
    regDate: Date;
    modUser: string;
    modDate: Date;
    reason: string;

    imageTest: string;

    according: string;
    observation:string;
    forceAccording: boolean;
    validatedUser: string;
    validatedDate: Date;
    position: number;
    accordingReason: string;
    uuidTest: string;
}

export class ExecutionQTestItem {
    id: number;
    idExecutionTest: number;
    idType: number;
    description: string;
    executionQTestItemVerification: ExecutionQTestItemVerification[];
   
}

export class ExecutionQTestItemVerification {
    id: number;
    idItem: number;
    verification: string;
    observation:string;
    executionQTestDataMultiple: ExecutionQTestData[];
    processingType: number;
    byteImage: string;
}

export class ExecutionQTestData {
    id: number;
	idVerification: number;
	expectedResultDesc: string;
	expectedResultRhDesc: string;
    obtainedResult:string;
    selectedResult: string;
	resultDesc: string[];
    uuid: string;
    idImage: number;
    executionQTestDeviations: ExecutionQTestDeviations[];
    observations: string[];
    regUser: string;
    regDate: Date;
    modUser: string;
    modDate: Date;
    reasonChange: string;
    uuidDeviation: string[];
    onlyLine: boolean;
    save: boolean;
    reasonChangeNoApplicable: string;
    selectExistDeviations: ExecutionQTestDeviations[];
    automatic: boolean = false;
    byteImage: string;
}


export class ExecutionQTestProbeTraceability {
    id: number;
    descriptionProbe: string;
    identifier: string;
    order: number;
    idExecutionTest: number;
    location: string;
    tacometer: boolean;
    idEquipment: number;
    external: boolean; 
}

export class ExecutionQTestResults{
    id: number;
    idExecutionTest: number;
    description: string;
    verification: string;
    obtainedResult: string;
    selectedResult: string;
	resultExpected: string[];
	result: string[];
    observation:string;
    executionQTestDeviations: ExecutionQTestDeviations;
}

export class ExecutionQTestDataOQ {
    id: number;
    idExecutionTest: number;
    test: string;
    descriptionTest: string;
    resultDesc: string[];
    selectedResult: string;
    observation: string;
    uuidDeviation: string[];
    idTestType: number;
    observations: string[];
    position: number;
    regUser: string;
    regDate: Date;
    modUser: string;
    modDate: Date;
    uuidTest: string;
}

export class ExecutionQTestBioindicadores {
    id: number;
    bioDescription: string;
    identifier: string;
    order: number;
    ExecutionTestId: number;
    control: string;
}

export class ExecutionQTestGeneralData{
    id:number;
    idExecutionTest:number;
    methodology:string;
    objective:string;
    criteria:string;
}

export class ExecutionQGeneralData {
    id: number;
    idExecution: number;
    precedents: string;
    target: string;
    scope: string;
    validationTeamResponsibility: string;
    clientResponsibility: string;
    engineeringResponsibility: string;
}

export class ExecutionQTestAttachment extends GenericAttachment{
    idTest: number;
    idAttachment: number;
    fromProtocol:boolean;
}


export class ExecutionQTestDeviations {
    id: number;
    codeDeviation: string;
    idDataMultiple: string;
    idExecution: number;
    idExecutionTest: number;
    idTestResult: number;
    executionQTestDeviationData: ExecutionQTestDeviationData[];
    modUser: string;
    modDate: Date;
    regDate: Date;
    regUser: string;
    idAttachment: number;
    file: File;
    uuid: string;
    uuidObs: string;
    observation: ExecutionQTestDataObservations;
    processingType: number;
}

export class ExecutionQTestDeviationData {
    id: number;
    idDeviation: number;
    idType: number;
    comments: string;
    closed: boolean;
    valuation: number;
    qualificationContinue: boolean;
    resolved: boolean;
    regUser: string;
    modUser: string;
    regFc: Date;
    modFc: Date;
}

export class ExecutionQTestItemGroup {
    id: number;
    idExecutionTest: number;
    executionQTestItems: ExecutionQTestItem[];
    numCycle: number;
    active: boolean;
    reasonActive: string;
    translationType: string;
    idTestType: number;
    idEssayType: number;
    title: string;
    uuid: string;
}

export class ExecutionQTestEssayGroup {
    id: number;
    
    idEssayType: number;
    dsType: string;
    translationType: string;

    idPeakEventType: number;

    essayValues: ExecutionQTestEssay[];

    active: boolean;
    reasonActive: string;

    title: string;
    additionalInfo: string;
    idPhoto: number;
    order: number;
    uuid: string;
    load: string;
}

export class ExecutionQTestEssay {
    id: number;

    idProtocol: number;
    dsProtocol: string;

    idConfig: number;
    idConfigDependsOn: number;
    idTypeDependency: number;

    criterias: Criteria[];

    percentSensorsCanFail: number;

    idVariable: number;
    translationVariable: string;

    idUnit: number;
    unitName: string;

    fcStartEssay: any;
    fcEndEssay: any;
    reasonModifyExpositionTime: string;

    sensors: Sensor[];
    fields: Field[];
    bioindicatorsConfig: BioindicatorConfig;
    endotoxinsConfig: BioindicatorConfig;

    idImage: number;

    dsLoad: string;
    setpoint: string;

    showBowieDick: boolean;
    validBowieDick: boolean;

    changeEssayDate: boolean;
    order: number;
}

export class ExecutionQTestDataObservations {
    id: number;
    idExecutionTest: number;
    description: string;
    position: number;
    regUser: string;
	modUser: string;
	regFc: Date;
	modFc: Date;
    notSelectedTest: boolean;
    autogenerated: boolean;
    uuid: string;
    uuidDeviation: string;
}

export class ExecutionQTestInstrumentalUsed {
    id: number;
    idExecutionTest: number;
    idInstrumentation: number;
    translation: string;
    validator: ValidatorSpecifics;
}

export class ExecutionQTestCriticalInstrumentation {
    id: number;
    idExecutionTest: number;
    equipment: string;
    internalId: string;
    procediment: string;
    maker: string;
    model: string;
    serialNum: string;
    certificateNum: string;
    idCertificate: number;
    reasonChange: string;
    showDiffInDeviations: boolean;
    showDiffInObservations: boolean;
    idEquipment: number;
    selectedResult: string;
    existsEvidence: string;
    observations: string[];
    uuidDeviation: string[];
    selectExistDeviations: ExecutionQTestDeviations[];
    regUser: string;
    modUser: string;
    regFc: Date;
    modFc: Date;
    uuid: string;
    save: boolean;
}

export enum TestTypeDeviations {
    COMMENTS = 1,
    VALUATION = 2,
    PROPOSED_CORRECTIVE = 3,
    ACTIONS_TAKEN = 4,
    DEVIATION_RESOLUTION = 5,
    DEVIATION_CLOSED = 6
}

export enum ExecutionAuditActionEnum {
    EDITION_NEW_VERSION=55,
    VALIDATE=5
}
